import { useCallback, useEffect, useRef } from "react";
import { useBlocker } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import {
  abandonDraftBooking,
  shouldAbandonDraft,
} from "../utils/abandonDraftBooking";

export function useAbandonDraftOnLeave(bookingUuid, bookingType, currentStatus, hasForeignPartnerClient = false) {
  const queryClient = useQueryClient();
  const bookingTypeRef = useRef(bookingType);
  const currentStatusRef = useRef(currentStatus);
  const hasForeignPartnerClientRef = useRef(hasForeignPartnerClient);
  bookingTypeRef.current = bookingType;
  currentStatusRef.current = currentStatus;
  hasForeignPartnerClientRef.current = hasForeignPartnerClient;

  const deletedRef = useRef(false);

  const abandonOnce = useCallback(async () => {
    if (
      !shouldAbandonDraft(bookingTypeRef.current, currentStatusRef.current, {
        hasForeignPartnerClient: hasForeignPartnerClientRef.current,
      }) ||
      !bookingUuid ||
      deletedRef.current
    ) {
      return true;
    }

    deletedRef.current = true;
    try {
      await abandonDraftBooking(bookingUuid);
      queryClient.removeQueries({ queryKey: ["booking", bookingUuid] });
      queryClient.invalidateQueries({ queryKey: ["bookingsPerUser"] });
      return true;
    } catch {
      deletedRef.current = false;
      return false;
    }
  }, [bookingUuid, queryClient]);

  const shouldBlock = useCallback(
    ({ currentLocation, nextLocation }) =>
      shouldAbandonDraft(bookingTypeRef.current, currentStatusRef.current, {
        hasForeignPartnerClient: hasForeignPartnerClientRef.current,
      }) &&
      !!bookingUuid &&
      !deletedRef.current &&
      currentLocation.pathname === `/book/${bookingUuid}` &&
      nextLocation.pathname !== currentLocation.pathname,
    [bookingUuid]
  );

  const blocker = useBlocker(shouldBlock);

  const handlingRef = useRef(false);

  useEffect(() => {
    if (blocker.state !== "blocked") {
      handlingRef.current = false;
      return;
    }

    if (handlingRef.current) return;
    handlingRef.current = true;

    abandonOnce().then((ok) => {
      if (blocker.state !== "blocked") return;
      if (ok) {
        blocker.proceed?.();
      } else {
        blocker.reset?.();
      }
    });
  }, [blocker, abandonOnce]);

  /*useEffect(() => {
    if (!canAbandon || !bookingUuid) return undefined;

    const handleBeforeUnload = () => {
      if (
        deletedRef.current ||
        !shouldAbandonDraft(bookingTypeRef.current, currentStatusRef.current)
      ) {
        return;
      }
      deletedRef.current = true;
      abandonDraftBookingKeepalive(bookingUuid);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [canAbandon, bookingUuid]);*/

  /*useEffect(() => {
    return () => {
      if (
        deletedRef.current ||
        !bookingUuid ||
        !shouldAbandonDraft(bookingTypeRef.current, currentStatusRef.current)
      ) {
        return;
      }
      deletedRef.current = true;
      abandonDraftBookingKeepalive(bookingUuid);
    };
  }, [bookingUuid]);*/

  return { abandonDraft: abandonOnce };
}
